import { faSearch } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { confirmTableModalData } from 'actions'
import {
	ITableModalButtonProps,
	ITableModalButtonState,
	ITableModalProps
} from 'models/TableModal'
import React, { Component } from 'react'
import { Col, Row } from 'react-bootstrap'
import { TransProps, WithTranslation, withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import TableModal from './TableModal'

class TableModalButton extends Component<
	ITableModalButtonProps & WithTranslation & TransProps,
	ITableModalButtonState
> {
	constructor(props: ITableModalButtonProps & WithTranslation & TransProps) {
		super(props)
		this.state = {
			showModal: false,
			selection: 0
		}
	}

	componentDidUpdate(
		prevProps: Readonly<ITableModalButtonProps>,
		prevState: Readonly<ITableModalButtonState>,
		snapshot?: any
	): void {
		const { tableModalAmount, handleConfirmResult } = this.props

		if (tableModalAmount && tableModalAmount !== prevProps.tableModalAmount) {
			handleConfirmResult(tableModalAmount.mensaje)
		}
	}

	handleOpenModal = () => {
		this.setState({ showModal: true })
	}

	handleConfirm = () => {
		const { confirmTableModalData, idOperacion, listCode } = this.props

		confirmTableModalData({
			idOperacion: idOperacion,
			cod_lista: listCode
		})

		this.setState({ showModal: false })
	}

	render() {
		const { idOperacion, listCode, modalTitle } = this.props
		const { showModal } = this.state

		const modalProps: ITableModalProps = {
			idOperacion: idOperacion,
			listCode: listCode,
			showModal: showModal,
			modalTitle: modalTitle,
			handleCloseModal: this.handleConfirm
		}

		return (
			<Row>
				<Col>
					<FontAwesomeIcon
						icon={faSearch}
						style={{ cursor: 'pointer', width: '20px', height: '20px' }}
						color={'#007bff'}
						title={modalTitle}
						onClick={() => this.handleOpenModal()}
					/>
				</Col>
				<Col>
					<TableModal {...modalProps} />
				</Col>
			</Row>
		)
	}
}

const mapStateToProps = ({ tableModal }: any) => {
	const { tableModalAmount } = tableModal
	return {
		tableModalAmount
	}
}

const connectForm = connect(mapStateToProps, {
	confirmTableModalData
})(TableModalButton)

export default withTranslation()(connectForm)
